import { apiHandler } from "../buyerApiHandler";

/**
 * Buyer App Dashboard settings. All stored as app_settings key/value rows on
 * the Buyer API and picked up by the app on its next load (no release needed).
 */

const jsonHeaders = { headers: { "Content-Type": "application/json" } };

export const getSetting = async (key: string): Promise<string> => {
  try {
    const res: any = await apiHandler("get", `/app-settings/${key}`);
    const value = res?.data?.value ?? res?.value ?? "";
    return typeof value === "string" ? value : "";
  } catch {
    return "";
  }
};

export const saveSetting = (
  key: string,
  value: string,
  category: string,
): Promise<any> =>
  apiHandler("post", "/app-settings", { key, value, category }, jsonHeaders);

export const DASHBOARD_KEYS = {
  storeBg: "STORE_DEAL_BG_COLOR",
  storeAccent: "STORE_DEAL_ACCENT_COLOR",
  storeAnimStyle: "STORE_DEAL_ANIM_STYLE",
  storeAnimSpeed: "STORE_DEAL_ANIM_SPEED",
  restaurantTitles: "HOME_RESTAURANTS_SECTION_TITLES",
  mapPinUrl: "MAP_PIN_ICON_URL",
  loaderLottieUrl: "LOADER_LOTTIE_URL",
  loaderLines: "LOADER_LINES",
} as const;

export const CATEGORY = {
  storeDeal: "store_deal",
  home: "home",
  map: "map",
  loader: "loader",
} as const;
